<template>
	<div>
		<v-navigation-drawer v-model="drawer" fixed width="600" right temporary stateless>
			<div class="drawer-wrapper company-detail-drawer">
				<v-flex class="py-3 px-5 d-flex border-bottom drawer-header">
					<div class="font-level-6-bold">Change Locale Inforamtion</div>
					<v-spacer></v-spacer>
					<v-btn depressed tile class="mr-2" v-on:click="$emit('close', true)">Cancel</v-btn>
					<v-btn
						tile
						depressed
						color="white--text"
						v-on:click="updateCompanyDetails"
						class="blue darken-4"
						>Save</v-btn
					>
				</v-flex>
				<div class="drawer-content pt-5 px-5">
					<p class="mt-0">
						You can change the access URL the way you want. Existing URL will stop working eventually.
					</p>
					<div class="mb-5 d-flex">
						<div class="d-flex pt-1 px-2 w-130">
							<label class="fw-500">Date Format</label>
						</div>
						<v-autocomplete
							:items="dateFormatList"
							depressed
							hide-details
							outlined
							v-model="company_details.date_format"
						></v-autocomplete>
					</div>
					<div class="mb-5 d-flex">
						<div class="d-flex pt-1 px-2 w-130">
							<label class="fw-500">Country</label>
						</div>
						<v-autocomplete
							:items="currencyList"
							depressed
							hide-details
							outlined
							v-model="company_details.currency"
						></v-autocomplete>
					</div>
					<div class="mb-5 d-flex">
						<div class="d-flex pt-1 px-2 w-130">
							<label class="fw-500">Time Zone</label>
						</div>
						<v-autocomplete
							:items="time_zoneList"
							depressed
							hide-details
							outlined
							v-model="company_details.timezone"
						></v-autocomplete>
					</div>
				</div>
			</div>
		</v-navigation-drawer>
	</div>
</template>
<script>
import { cloneDeep } from "lodash";
import { UpdateCompanyDetails } from "@/core/lib/setting.lib";
import { SET_ERROR, SET_MESSAGE } from "@/core/services/store/common.module";
export default {
	name: "LocalInformation",
	props: {
		drawer: {
			type: Boolean,
			default: false,
		},
		details: {
			type: Object,
			default: new Object(),
		},
	},
	data() {
		return {
			company_details: {
				date_format: null,
				currency: null,
				timezone: null,
			},
			currencyList: ["Singapore"],
			time_zoneList: ["(GMT -11:0) GMT-11:00 (Etc/GMT+11)", "(GMT -11:0) GMT-11:00 (Etc/GMT+12)"],
			dateFormatList: ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD"],
		};
	},
	watch: {
		details: {
			deep: true,
			immediate: true,
			handler(param) {
				this.company_details = cloneDeep(param);
			},
		},
	},
	methods: {
		updateCompanyDetails() {
			UpdateCompanyDetails(this.company_details)
				.then(() => {
					this.$store.commit(SET_MESSAGE, [
						{ model: true, message: "Success ! Company details has been updated." },
					]);
					this.$emit("success", true);
					this.$emit("close", true);
				})
				.catch((error) => {
					this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
				})
				.finally(() => {
					this.pageLoading = false;
				});
		},
	},
};
</script>
<style scoped></style>
